module.exports = __webpack_public_path__ + "img/report.274cedee.svg";